import {
  forge,
  EncodeJSON,
  Retry,
  Timeout,
  correlationIdMiddleware,
  Client,
} from '@modifi/api-clients'
import {clientConfig} from '@modifi/client-config'

const resources = {
  Version: {
    buildVersionMatch: {path: '/api/v1/version/buildVersionMatch', method: 'get'},
  },
}

export const serviceClient = (): Client<typeof resources> => {
  const client = forge({
    middlewares: [
      correlationIdMiddleware,
      Retry({
        retries: 2,
      }),
      EncodeJSON,
      Timeout(60 * 1000),
    ],
    host: clientConfig.get('hostname', '') as string,
    resources,
  })
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    // @ts-ignore
    window.serviceClient = client
  }

  return client
}
